import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { SvgIcon } from 'components/SvgIcon';

const styles = require('./userInfos.css');

interface IProps {
  infos: string[];
}

export default class UserInfos extends BaseComponent<any, IProps> {
  render() {
    return (
      <div className={`${styles.component} chk-userInfos`}>
        {
          this.props.infos.map((info, key) => {
            return (
              <div className='chk-userInfos__content' key={key}>
                <SvgIcon name='checkIcon' />
                <span>{info}</span>
              </div>
            );
          })
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/OneClickBuy/UserInfos/index.tsx